import { createSelector } from "reselect";
import {
  getDischargeSteps,
  getCurrentModuleSlug,
  getCurrentTopicSlug
} from "./core";
import { getCurrentProgress } from "./progress";

const mapStepToProgress = (step, progress) => {
  const found = progress.find(({ chapterId }) => chapterId === step.ID);
  if (!found) {
    return {
      ...step,
      completion: 0,
      topics: step.topics.map(topic => ({ ...topic, completed: false }))
    };
  }

  const completedTopics = [];
  // steps.topics.include
  const stepCompletedTopics = step.topics.map(topic => {
    const completed = found.topics.includes(topic.ID);
    if (completed) {
      completedTopics.push(topic.ID);
    }
    return {
      ...topic,
      completed
    };
  });

  const newStep = { ...step };
  newStep.topics = stepCompletedTopics;

  return {
    ...newStep,
    completion: (completedTopics.length / step.topics.length) * 100 || 0
  };
};

const getDischargeProgress = createSelector(
  getDischargeSteps,
  getCurrentProgress,
  (steps, progress) =>
    Array.isArray(steps) && Array.isArray(progress)
      ? steps.map(step => mapStepToProgress(step, progress))
      : undefined
);

const getDischargeFullyComplete = createSelector(getDischargeProgress, steps =>
  Array.isArray(steps)
    ? steps.reduce((acc, step) => acc && step.completion === 100, true)
    : false
);

const getCurrentDischargeStepProgress = createSelector(
  getDischargeProgress,
  getCurrentModuleSlug,
  (steps, lessonSlug) => {
    if (typeof steps !== "undefined") {
      return steps[parseInt(lessonSlug, 10) - 1];
    }
    return null;
  }
);

const getCurrentDischargeStepTopicProgress = createSelector(
  getCurrentDischargeStepProgress,
  getCurrentTopicSlug,
  (step, topicSlug) => {
    if (step) {
      const topic = step.topics[parseInt(topicSlug, 10)];
      return {
        ...topic,
        lastTopic: parseInt(topicSlug, 10) === step.topics.length - 1
      };
    }
    return null;
  }
);

export {
  getDischargeProgress,
  getCurrentDischargeStepProgress,
  getCurrentDischargeStepTopicProgress,
  getDischargeFullyComplete
};



// WEBPACK FOOTER //
// ./src/selectors/dischargeProgress.js